import { Helmet } from "react-helmet";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import DetailAccentCard from "../detail/DetailAccentCard";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import Loading from "../loading/Loading";

export default function EditorPageLayout({
	isDesktop,
	pageTitle,
	metaDescription,
	breadcrumbLinks = [],
	wide = false,
	isLoading = false,
	loadError = "",
	children,
	showFooter = false,
	footerActiveButton,
}) {
	const mainClass = wide
		? "mx-auto w-full max-w-[900px] flex-1 px-4 py-6 md:py-8 pb-12"
		: "mx-auto w-full max-w-[720px] flex-1 px-4 py-6 md:py-8 pb-12";

	return (
		<>
			{pageTitle && (
				<Helmet>
					<title>{pageTitle} | همراهتیم</title>
					{metaDescription && (
						<meta name="description" content={metaDescription} />
					)}
				</Helmet>
			)}

			<div className="flex min-h-screen flex-col bg-[#F0F6FC]">
				<Header isDesktop={isDesktop} />
				{breadcrumbLinks.length > 0 && (
					<div className="bg-white">
						<div
							className={`${isDesktop ? "mx-auto w-full max-w-[1200px]" : ""} px-4`}
						>
							<Breadcrumb linkDataList={breadcrumbLinks} />
						</div>
					</div>
				)}
				<main className={mainClass}>
					{isLoading && (
						<div className="flex justify-center py-16">
							<Loading color="#ff694b" width={44} />
						</div>
					)}
					{loadError && !isLoading && (
						<DetailAccentCard bodyClassName="p-6">
							<p className="text-center font-Vazir-400 text-[#cc0000]">
								{loadError}
							</p>
						</DetailAccentCard>
					)}
					{!isLoading && !loadError && children}
				</main>
				{showFooter && (
					<Footer isDesktop={isDesktop} activeButton={footerActiveButton} />
				)}
			</div>
		</>
	);
}
